import VODSearchResults from './VODSearchResults';

export default VODSearchResults;